(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daughters-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="DogDetail-"]');
    sections.forEach(function (sec) {
      if (sec.dataset.dogDetailInit === '1') return;
      sec.dataset.dogDetailInit = '1';

      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (!els.length) return;
      els.forEach(function (el, i) { el.style.setProperty('--rd', (i * 60) + 'ms'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daughters-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="DogGrid-"]');
    sections.forEach(function (sec) {
      if (sec.dataset.dogGridInit === '1') return;
      sec.dataset.dogGridInit = '1';

      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (!els.length) return;
      els.forEach(function (el, i) { el.style.setProperty('--rd', (i * 80) + 'ms'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daughters-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="DogHeroGraphic-"]');
    sections.forEach(function (mount) {
      if (mount.dataset.dogInit === '1') return;
      mount.dataset.dogInit = '1';

      var svg = mount.querySelector('svg');
      if (!svg) {
        mount.classList.add('is-mounted', 'is-awakened');
        return;
      }

      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

      var paths = svg.querySelectorAll('path');
      if (!paths.length) {
        mount.classList.add('is-mounted', 'is-awakened');
        return;
      }

      var ANCHORS = [
        { x: 310, y: 230 },
        { x: 322, y: 380 }
      ];
      var BASE_DELAY    = 700;
      var STAGGER_RANGE = 3800;
      var SETTLE_BUFFER = 2200;

      var items = [];
      var maxDist = 0;
      paths.forEach(function (p) {
        var bb;
        try { bb = p.getBBox(); } catch (e) { bb = { x: 0, y: 0, width: 0, height: 0 }; }
        var px = bb.x + bb.width / 2;
        var py = bb.y + bb.height / 2;
        var dist = Infinity;
        for (var i = 0; i < ANCHORS.length; i++) {
          var d = Math.hypot(px - ANCHORS[i].x, py - ANCHORS[i].y);
          if (d < dist) dist = d;
        }
        if (dist > maxDist) maxDist = dist;
        items.push({ path: p, dist: dist });
      });

      items.forEach(function (item) {
        var t = maxDist > 0 ? item.dist / maxDist : 0;
        var eased = t * t * (3 - 2 * t);
        var delay = BASE_DELAY + Math.round(eased * STAGGER_RANGE);
        var jitter = (Math.random() - 0.5) * 240;
        item.path.style.setProperty('--p-delay', (delay + jitter) + 'ms');
      });

      // The awakening plays when the graphic scrolls into view rather than on
      // page load, since the section now sits below the video hero.
      function awaken() {
        requestAnimationFrame(function () {
          mount.classList.add('is-mounted');
          requestAnimationFrame(function () {
            mount.classList.add('is-awakened');
          });
        });

        setTimeout(function () {
          mount.classList.add('is-breathing');
        }, BASE_DELAY + STAGGER_RANGE + SETTLE_BUFFER);
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              io.unobserve(e.target);
              awaken();
            });
          },
          { threshold: 0.15 }
        );
        io.observe(mount);
      } else {
        awaken();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daughters-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="DogManifesto-"]');
    sections.forEach(function (sec) {
      if (sec.dataset.dogManifestoInit === '1') return;
      sec.dataset.dogManifestoInit = '1';

      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (!els.length) return;
      els.forEach(function (el, i) { el.style.setProperty('--rd', (i * 100) + 'ms'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-blue-chip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="GalChip-"]');
    sections.forEach(function (sec) {
      if (sec.dataset.galChipInit === '1') return;
      sec.dataset.galChipInit = '1';

      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (!els.length) return;
      els.forEach(function (el, i) { el.style.setProperty('--rd', (i * 80) + 'ms'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="GalDetail-"]');
    sections.forEach(function (sec) {
      if (sec.dataset.galDetailInit === '1') return;
      sec.dataset.galDetailInit = '1';

      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (!els.length) return;
      els.forEach(function (el, i) { el.style.setProperty('--rd', (i * 60) + 'ms'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="GalIndex-"]');
    sections.forEach(function (sec) {
      if (sec.dataset.galIndexInit === '1') return;
      sec.dataset.galIndexInit = '1';

      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (!els.length) return;
      els.forEach(function (el, i) { el.style.setProperty('--rd', (i * 70) + 'ms'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-scroll-zoom"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* All hero entrance animations fire concurrently after a short
     settle, so the heading chars, image, sub copy, and signature
     breathe in together rather than in sequence. */
  var ENTRANCE_DELAY_MS = 150;
  var CHAR_STAGGER_S    = 0.046;

  function init() {
    var wrapper = document.querySelector('[id^="GDHero-"]');
    if (!wrapper) return;

    var frame     = wrapper.querySelector('[data-gd-frame]');
    var signature = wrapper.querySelector('[data-gd-signature]');
    var heading   = wrapper.querySelector('[data-gd-heading]');
    var subs      = wrapper.querySelectorAll('[data-gd-sub]');

    primeSignature(signature);
    splitHeading(heading);

    var startSec = ENTRANCE_DELAY_MS / 1000;

    /* Heading chars: each has its own per-char delay set in splitHeading;
       offset them all by the entrance delay so they cascade from t = 0. */
    var chars = heading ? heading.querySelectorAll('.gd-char') : [];
    chars.forEach(function (span, i) {
      span.style.animationDelay     = (startSec + i * CHAR_STAGGER_S) + 's';
      span.style.animationPlayState = 'running';
    });

    subs.forEach(function (el) {
      el.style.animationDelay     = startSec + 's';
      el.style.animationPlayState = 'running';
    });

    setTimeout(function () {
      requestAnimationFrame(function () {
        if (frame) frame.classList.add('gd-hero__frame--visible');
        if (signature) {
          signature.classList.add('gd-hero__signature--armed');
          requestAnimationFrame(function () {
            signature.classList.add('gd-hero__signature--draw');
          });
        }
      });
    }, ENTRANCE_DELAY_MS);
  }

  function splitHeading(heading) {
    if (!heading || heading.dataset.gdSplit) return;
    heading.dataset.gdSplit = '1';

    function processNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var frag = document.createDocumentFragment();
        Array.from(node.textContent).forEach(function (ch) {
          if (ch.trim() === '') {
            frag.appendChild(document.createTextNode(ch));
          } else {
            var span = document.createElement('span');
            span.className   = 'gd-char';
            span.textContent = ch;
            frag.appendChild(span);
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(processNode);
      }
    }

    Array.from(heading.childNodes).forEach(processNode);
  }

  /* Measure each signature path, set its dash length, and stagger
     the per-path draw delay so the strokes write in source order
     (already left-to-right). Speed is constant per unit-length so it
     reads like a real hand signing. */
  function primeSignature(sig) {
    if (!sig) return;
    var paths = sig.querySelectorAll('path');
    if (!paths.length) return;
    var SPEED = 320;        /* svg units per second */
    var GAP   = 0.06;       /* seconds of pause between strokes */
    var cursor = 0;
    paths.forEach(function (p) {
      var len = 0;
      try { len = p.getTotalLength(); } catch (e) { len = 600; }
      var dur = Math.max(0.45, len / SPEED);
      p.style.setProperty('--len', len);
      p.style.setProperty('--draw-duration', dur + 's');
      p.style.setProperty('--draw-delay', cursor + 's');
      cursor += dur + GAP;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-text-animation"]) return;
  try {
    
  (function () {

    /* ── Config ── */
    var STAGGER       = 0.048;
    var IMAGE_FADE_MS = 1200;
    var IMAGE_HOLD_MS = 4000;
    var mount  = document.querySelector('.hero-anim-mount');
    var IMAGES = mount ? [
      mount.dataset.img1,
      mount.dataset.img2,
      mount.dataset.img3
    ] : [];

    /* ── Helpers ── */
    function raf2(fn) {
      requestAnimationFrame(function () { requestAnimationFrame(fn); });
    }

    /* ── H1 char split ── */
    function splitAndAnimate() {
      var allH1s  = document.querySelectorAll('h1');
      var heading = null;
      allH1s.forEach(function (h) {
        if (h.textContent.includes('Sacred') || h.textContent.includes('Forged')) {
          heading = h;
        }
      });

      if (!heading || heading.dataset.heroAnimDone) return;
      heading.dataset.heroAnimDone = '1';

      var headingBlock = heading.closest('[class*="text-block"]') || heading.parentElement;
      var parent       = headingBlock ? headingBlock.parentElement : null;

      /* Insert stage immediately so text fades in at its final position */
      var stage  = buildStage();
      var slides = Array.from(stage.querySelectorAll('.hero-image-slide'));
      if (parent) {
        parent.insertBefore(stage, headingBlock);
      }

      /* Split h1 into chars */
      var charIndex = 0;

      function processNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          var chars = Array.from(node.textContent);
          var frag  = document.createDocumentFragment();
          chars.forEach(function (char) {
            if (char === ' ') {
              frag.appendChild(document.createTextNode('\u00a0'));
            } else {
              var span = document.createElement('span');
              span.className = 'hero-char';
              span.style.animationDelay = (charIndex * STAGGER) + 's';
              span.textContent = char;
              charIndex++;
              frag.appendChild(span);
            }
          });
          node.parentNode.replaceChild(frag, node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          Array.from(node.childNodes).forEach(processNode);
        }
      }

      Array.from(heading.childNodes).forEach(processNode);

      /* Subheader */
      var subDelay = (charIndex * STAGGER) + 0.65;
      var subBlock = headingBlock ? headingBlock.nextElementSibling : null;
      if (subBlock) {
        subBlock.classList.add('hero-subheader-animate');
        subBlock.style.animationDelay = subDelay + 's';
      }

      /* Fade image in after text + subheader are fully visible */
      var imageStartMs = (subDelay + 1.1 + 0.4) * 1000;
      setTimeout(function () {
        raf2(function () {
          stage.classList.add('hero-image-stage--visible');
          slides[0].classList.add('hero-image-slide--active');
        });
        startCycle(slides);
      }, imageStartMs);
    }

    /* ── Build image stage ── */
    function buildStage() {
      var stage = document.createElement('div');
      stage.className = 'hero-image-stage';
      IMAGES.forEach(function (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.className = 'hero-image-slide';
        stage.appendChild(img);
      });
      return stage;
    }

    /* ── Fade out then fade in cycle ── */
    function startCycle(slides) {
      var current = 0;

      function cycleNext() {
        var next = (current + 1) % slides.length;

        /* Fade out current first */
        slides[current].classList.remove('hero-image-slide--active');

        /* After current is gone, fade in next */
        setTimeout(function () {
          slides[next].classList.add('hero-image-slide--active');
          current = next;
          setTimeout(cycleNext, IMAGE_HOLD_MS);
        }, IMAGE_FADE_MS);
      }

      setTimeout(cycleNext, IMAGE_HOLD_MS);
    }

    splitAndAnimate();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["narrative-block"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* IntersectionObserver for scroll reveal, runs once per page regardless
     of how many narrative-block sections are rendered.                     */

  function initReveal() {
    var targets = document.querySelectorAll('.gd-reveal, .gd-reveal-fade, .gd-reveal-line, .gd-reveal-graphic');
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gd-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[id^="Pxf-"]').forEach(function (sec) {
      if (sec.dataset.pxfInit === '1') return;
      sec.dataset.pxfInit = '1';

      // Reveal
      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (els.length) {
        els.forEach(function (el, i) { el.style.setProperty('--rd', i * 100 + 'ms'); });
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                io.unobserve(e.target);
              }
            });
          },
          { threshold: 0.08 }
        );
        els.forEach(function (el) { io.observe(el); });
      }

      // Parallax
      var media = sec.querySelector('[data-pxf-media]');
      if (!media || reduce) return;

      var depth = parseFloat(getComputedStyle(sec).getPropertyValue('--pxf-depth')) || 0;
      if (!depth) return;

      var ticking = false;
      var visible = false;

      function update() {
        ticking = false;
        var rect = sec.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        // -1 when the section is just below the fold, 1 when just above it.
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        progress = Math.max(-1, Math.min(1, progress));
        media.style.transform = 'translate3d(0,' + (progress * depth).toFixed(2) + 'px,0)';
      }

      function onScroll() {
        if (!visible || ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) update();
        });
      });
      vio.observe(sec);

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[id^="Stmt-"]').forEach(function (sec) {
      if (sec.dataset.stmtInit === '1') return;
      sec.dataset.stmtInit = '1';

      var els = sec.querySelectorAll('.gd-r-fade, .gd-r-rise, .gd-r-line');
      if (!els.length) return;
      els.forEach(function (el, i) { el.style.setProperty('--rd', i * 110 + 'ms'); });

      sec.classList.add('is-armed');

      if (!('IntersectionObserver' in window)) {
        sec.classList.add('is-in');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            requestAnimationFrame(function () { sec.classList.add('is-in'); });
          });
        },
        { threshold: 0.2 }
      );
      io.observe(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function splitChars(wrap) {
      var heading = wrap.querySelector('.vhero__heading');
      if (!heading) return null;

      var text = (heading.textContent || '').trim();
      if (!text) return null;

      var spread = parseFloat(wrap.dataset.charWindow) || 1200;
      var duration = parseFloat(wrap.dataset.charDuration) || 1200;

      heading.setAttribute('aria-label', text);

      var frag = document.createDocumentFragment();
      var chars = [];
      var breakMobile = wrap.hasAttribute('data-break-mobile');
      var wordIndex = 0;

      // Split on whitespace but keep it, so spaces stay real break points
      // while each word becomes an unbreakable box.
      text.split(/(\s+)/).forEach(function (token) {
        if (!token) return;
        if (/^\s+$/.test(token)) {
          frag.appendChild(document.createTextNode(token));
          return;
        }
        var word = document.createElement('span');
        word.className = 'vhero__word';
        word.setAttribute('aria-hidden', 'true');
        token.split('').forEach(function (ch) {
          var span = document.createElement('span');
          span.className = 'vhero__char';
          span.textContent = ch;
          word.appendChild(span);
          chars.push(span);
        });
        frag.appendChild(word);

        wordIndex++;
        if (breakMobile && wordIndex === 1) {
          var br = document.createElement('br');
          br.className = 'vhero__wbr';
          br.setAttribute('aria-hidden', 'true');
          frag.appendChild(br);
        }
      });

      if (!chars.length) return null;

      heading.textContent = '';
      heading.appendChild(frag);

      // Random rather than sequential, so the word resolves out of noise.
      chars.forEach(function (span) {
        span.style.setProperty('--char-delay', Math.round(Math.random() * spread) + 'ms');
        span.style.setProperty('--char-dur', duration + 'ms');
      });

      return heading;
    }

    // Scale the heading so its natural single-line width exactly fills the
    // measure. Beats guessing a font size that happens to fit one viewport.
    var FIT_MIN = 750; // below this the heading wraps at a CSS-controlled size

    function fit(sec) {
      var heading = sec.querySelector('.vhero__heading');
      var inner = sec.querySelector('.vhero__inner');
      if (!heading || !inner) return;

      // Hand sizing back to CSS on small screens.
      if (window.innerWidth < FIT_MIN) {
        heading.style.fontSize = '';
        return;
      }

      var cs = getComputedStyle(inner);
      var avail =
        inner.clientWidth -
        parseFloat(cs.paddingLeft || 0) -
        parseFloat(cs.paddingRight || 0);

      // Never measure against a box that has collapsed onto its own content;
      // fall back to the section, which is always viewport width.
      var secWidth = sec.clientWidth;
      if (secWidth && avail > secWidth) avail = secWidth;
      if (avail <= 0) return;

      // Measure at a known reference size rather than the current one, so
      // repeated fits cannot drift or compound.
      heading.style.fontSize = '100px';
      var natural = heading.scrollWidth;
      if (!natural) { heading.style.fontSize = ''; return; }

      heading.style.fontSize = (100 * avail) / natural + 'px';
    }

    // Fade the fixed backdrop down as the first viewport scrolls away.
    function bindScrollDim(sec) {
      var media = sec.querySelector('.vhero__media');
      if (!media) return;

      function pct(v, fallback) {
        var n = parseFloat(v);
        if (isNaN(n)) n = fallback;
        return Math.max(0, Math.min(100, n)) / 100;
      }

      // Two stops: the first viewport fades to `floor`, then continuing
      // deeper into the page settles to `deep`.
      var floor = pct(sec.dataset.scrollDim, 21);
      var deep = pct(sec.dataset.scrollDimDeep, 8);
      var deepSpan = parseFloat(sec.dataset.scrollDimSpan) || 2;

      var ticking = false;

      function update() {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (!vh) return;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;

        var opacity;
        if (y <= vh) {
          opacity = 1 - (y / vh) * (1 - floor);
        } else {
          var p = Math.max(0, Math.min(1, (y - vh) / (vh * deepSpan)));
          opacity = floor - p * (floor - deep);
        }

        media.style.setProperty('--vhero-media-opacity', opacity.toFixed(3));
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function init() {
      document.querySelectorAll('[id^="VHero-"]').forEach(function (sec) {
        if (sec.dataset.vheroInit === '1') return;
        sec.dataset.vheroInit = '1';

        if (sec.hasAttribute('data-vhero-fixedbg')) bindScrollDim(sec);

        var wrap = sec.querySelector('[data-vhero-chars]');
        var split = wrap ? splitChars(wrap) : null;

        // Hide the letters the moment they are split. Waiting until after the
        // font resolves meant the heading flashed in fully formed, vanished,
        // then faded back — which read as no animation at all.
        if (split) wrap.classList.add('is-anim');

        var doFit = sec.classList.contains('vhero--heading-fit');

        var started = false;
        function run() {
          if (started) return;
          started = true;
          if (doFit) fit(sec);
          if (split) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                wrap.classList.add('is-in');
              });
            });
          }
        }

        // Fitting against a fallback face would resize once the real font
        // swaps in, so wait for it when the browser can tell us.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(run);
          // Never let a font that never resolves leave the heading hidden.
          setTimeout(run, 3000);
        } else {
          run();
        }

        if (!doFit) return;

        var t;
        window.addEventListener(
          'resize',
          function () {
            clearTimeout(t);
            t = setTimeout(function () { fit(sec); }, 120);
          },
          { passive: true }
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wordmark-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[id^="Gdmark-"]').forEach(function (sec) {
      if (sec.dataset.gdmarkInit === '1') return;
      sec.dataset.gdmarkInit = '1';

      var svg = sec.querySelector('.gdmark__svg svg');
      if (!svg) return;

      var paths = svg.querySelectorAll('path');
      if (!paths.length) return;

      // Stagger left to right by horizontal position, so the reveal reads as
      // the wordmark being written rather than as document order.
      var step = parseFloat(getComputedStyle(sec).getPropertyValue('--gdmark-stagger')) || 90;
      var items = [];
      paths.forEach(function (p) {
        var x;
        try { x = p.getBBox().x; } catch (e) { x = 0; }
        items.push({ path: p, x: x });
      });
      items.sort(function (a, b) { return a.x - b.x; });
      items.forEach(function (item, i) {
        item.path.style.setProperty('--pd', i * step + 'ms');
      });

      sec.classList.add('is-armed');

      if (!('IntersectionObserver' in window)) {
        sec.classList.add('is-in');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            requestAnimationFrame(function () {
              sec.classList.add('is-in');
            });
          });
        },
        { threshold: 0.25 }
      );
      io.observe(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
